export const SET_MAP_CONFIG = 'SET_MAP_CONFIG'
export const SET_LAYER_DATA = 'SET_LAYER_DATA'
export const SET_PROJECTION_DATA = 'SET_PROJECTION_DATA'
export const SET_RENDERING_ADAPTER_DATA = 'SET_RENDERING_ADAPTER_DATA'
export const UPDATE_MAP_CONFIG = 'UPDATE_MAP_CONFIG'
